import Boss from "./Boss";

export default class BossSpirit extends Boss {
    constructor() {
        super("adversary_spirit", Boss.TYPE_SPIRIT);

        this.scale.set(0.4);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._attackSoundName = "sfx_spirit_attack_00";
        this._enterSoundName = "sfx_enter_spirit";
    }

    init() {
        super.init(P3.utils.selectRandom(["spirit1", "spirit2"]));
    }
}